import { css } from '@emotion/react'
import Link from 'next/link'
import { colors, font, mq } from 'plume-ui'
import React from 'react'
import Slider, { Settings } from 'react-slick'
import { ContentfulNpStartupSlideArticle } from '../../types'

type Props = {
  slideBannerArticles: ContentfulNpStartupSlideArticle[] | null
  trackingIdPrefix: string
}

export const MobileGuestSlideBanner: React.VFC<Props> = (props) => {
  const sliderSettings: Settings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: true,
    swipeToSlide: true,
    touchThreshold: 10,
  }
  const articles = props.slideBannerArticles
  if (!articles || articles?.length === 0) return null

  return (
    <div
      data-testid="guest-mobile-slide-banner-section"
      css={css`
        display: none;
        ${mq.untilMedium} {
          display: block;
          background-color: ${colors.white00};
          padding: 24px 16px 8px 16px;
        }
      `}
    >
      <div
        css={css`
          line-height: 1.25;
          letter-spacing: 0.02em;
          color: ${colors.black10};
          color: ${colors.textStrong};
          margin-bottom: 16px;
        `}
      >
        <div
          css={css`
            font-size: 12px;
            font-weight: ${font.weight.normal};
            margin-bottom: 4px;
          `}
        >
          スタートアップ投資・協業の情報収集に
        </div>
        <div
          css={css`
            font-size: 20px;
            font-weight: ${font.weight.bold};
          `}
          data-testid="main-caption"
        >
          お役立ち情報をチェック
        </div>
      </div>
      <div
        css={css`
          width: 100%;
          margin-bottom: 40px;
        `}
      >
        <Slider
          {...sliderSettings}
          css={css`
            .slick-slide {
              padding-left: 8px;
            }
            .slick-dots {
              bottom: -30px;
              line-height: 0;
              > li {
                margin: 0;
                > button::before {
                  left: auto;
                  top: auto;
                  content: '';
                  width: 8px;
                  height: 8px;
                  background-color: ${colors.gray50};
                  border-radius: 100%;
                  transform: translate(-50%, -50%);
                  opacity: 1;
                }
                &.slick-active > button::before {
                  background-color: ${colors.gray90} !important;
                }
              }
            }
          `}
        >
          {articles.map((article, index) => (
            <SlideBanner
              key={index}
              imageUrl={article.articleBannerImageUrl}
              href={article.articleUrl}
              id={
                `${props.trackingIdPrefix}-sb-image` +
                ('00' + (index + 1)).slice(-2)
              }
            />
          ))}
        </Slider>
      </div>
    </div>
  )
}

type SlideBannerProps = {
  imageUrl: string
  href: string
  id?: string
}

const SlideBanner: React.VFC<SlideBannerProps> = (props) => {
  return (
    <div
      css={css`
        [data-index='0'] & {
          margin-left: 8px;
        }
        ${mq.max(320)} {
          width: 240px;
          height: 240px;
        }
      `}
    >
      <Link href={props.href} passHref>
        <a id={props.id} target="_blank" rel="noopener noreferrer">
          <img
            css={css`
              border-radius: 4px;
            `}
            src={props.imageUrl}
            width="280"
            height="280"
            data-testid="banner-image"
          />
        </a>
      </Link>
    </div>
  )
}
